import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
				path: '/',
				redirect: '/home'
			}, {
				path: '/home',
				name: 'home',
				component: resolve => require(['@/view/HomePage'], resolve),
				meta: {
					title: '首页'
				}
			}, {
				path: '/watch',
				name: 'watch',
				component: resolve => require(['@/view/watch'], resolve),
				meta: {
					title: '核心业务'
				}
			}, {
				path: '/companyintroduction',
				name: 'companyintroduction',
				component: resolve => require(['@/view/CompanyIntroduction'], resolve),
				meta: {
					title: '资讯中心'
				}
			},
			{
				path: '/trademark',
				name: 'trademark',
				component: resolve => require(['@/view/trademark'], resolve),
				meta: {
					title: '商标注册'
				}
			},
			{
				path: '/copyright',
				name: 'copyright',
				component: resolve => require(['@/view/copyright'], resolve),
				meta: {
					title: '版权登记'
				}
			},
			{
				path: '/accounting',
				name: 'accounting',
				component: resolve => require(['@/view/accounting'], resolve),
				meta: {
					title: '代理记账'
				}
			},
			{
				path: '/taxation',
				name: 'taxation',
				component: resolve => require(['@/view/taxation'], resolve),
				meta: {
					title: '税务规划'
				}
			},

			{
				path: '/audit',
				name: 'audit',
				component: resolve => require(['@/view/audit'], resolve),
				meta: {
					title: '公司审计'
				}
			},
			{
				path: '/phone',
				name: 'phone',
				component: resolve => require(['@/view/phone'], resolve),
				meta: {
					title: '产品中心'
				}
			},
			{
				path: '/publicWelfare',
				name: 'publicWelfare',
				component: resolve => require(['@/view/publicWelfare'], resolve),
				meta: {
					title: '关于我们'
				}
			},
			{
				path: '/register',
				name: 'register',
				component: resolve => require(['@/view/register'], resolve),
				meta: {
					title: '注册'
				}
			},
			{
				path: '/forgotPassword',
				name: 'forgotPassword',
				component: resolve => require(['@/view/forgotPassword'], resolve),
				meta: {
					title: '忘记密码'
				}
			},
			{
				path: '/login',
				name: 'login',
				component: resolve => require(['@/view/login'], resolve),
				meta: {
					title: '登录'
				}
			},
			{
				path: '/message',
				name: 'message',
				component: resolve => require(['@/view/message'], resolve),
				meta: {
					title: '留言板'
				}
			},
			{
				path: '/newsDetail',
				name: 'newsDetail',
				component: resolve => require(['@/view/newsDetail'], resolve),
				meta: {
					title: '新闻详情'
				}
			},
			{
				path: '/publicDetail',
				name: 'publicDetail',
				component: resolve => require(['@/view/publicDetail'], resolve),
				meta: {
					title: '产品详情'
				}
			},
			{
				path: '/orderList',
				name: 'orderList',
				component: resolve => require(['@/view/orderList'], resolve),
				meta: {
					title: '订单列表'
				}
			}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js